import { Flex, Input, Text } from '@optiaxiom/react';

import { styles } from './FormInput.css.ts';

type FormInputProps = {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  type?: string;
};

export function FormInput({
  label,
  name,
  value,
  onChange,
  placeholder,
  required,
  disabled,
  type,
}: FormInputProps) {
  return (
    <Flex className={styles.formItem} flexDirection="column">
      <Text color="fg.secondary">{label}</Text>
      <Input
        value={value}
        name={name}
        onChange={onChange}
        className={styles.formInput}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        type={type}
      />
    </Flex>
  );
}
